import { ActionTypes } from "store/actions/splashScreen";

const defaultSessionState = {
  splashScreenVisibilityStatus: true,
};

function splashScreen(state = defaultSessionState, action) {
  switch (action.type) {
    case ActionTypes.SET_SS_VISIBILITY:
      return {
        ...action.session,
        splashScreenVisibilityStatus: action.payload,
      };

    default:
      return state;
  }
}

export default splashScreen;



// WEBPACK FOOTER //
// ./src/js/store/reducers/splashScreen.js